export const COLOMBIA_CITIES = [
  'Aguachica',
  'Apartadó',
  'Arauca',
  'Armenia',
  'Barrancabermeja',
  'Barranquilla',
  'Bello',
  'Bogotá',
  'Bucaramanga',
  'Buenaventura',
  'Cajicá',
  'Cali',
  'Cartagena',
  'Cartago',
  'Chía',
  'Ciénaga',
  'Copacabana',
  'Cúcuta',
  'Dosquebradas',
  'Duitama',
  'Envigado',
  'Facatativá',
  'Florencia',
  'Floridablanca',
  'Fontibón',
  'Funza',
  'Fusagasugá',
  'Girardot',
  'Girón',
  'Guadalajara de Buga',
  'Ibagué',
  'Inírida',
  'Ipiales',
  'Itagüí',
  'Jamundí',
  'La Estrella',
  'La Jagua de Ibirico',
  'La Virginia',
  'Leticia',
  'Madrid',
  'Magangué',
  'Maicao',
  'Malambo',
  'Manizales',
  'Medellín',
  'Mitú',
  'Mocoa',
  'Montería',
  'Mosquera',
  'Neiva',
  'Ocaña',
  'Palermo',
  'Palmira',
  'Pasto',
  'Pereira',
  'Piedecuesta',
  'Pitalito',
  'Popayán',
  'Puerto Carreño',
  'Quibdó',
  'Ríohacha',
  'Rionegro',
  'Sabanalarga',
  'Sabaneta',
  'San Andrés',
  'San José del Guaviare',
  'Santa Marta',
  'Santander de Quilichao',
  'Sincelejo',
  'Soacha',
  'Sogamoso',
  'Soledad',
  'Tuluá',
  'Tumaco',
  'Tunja',
  'Turbaco',
  'Turbo',
  'Uribia',
  'Uripa',
  'Usme',
  'Valledupar',
  'Villavicencio',
  'Yopal',
  'Zipaquirá',
]
